import React from "react";
import CodeEditorMock from "../Panels/CodeEditorMock";
import ReactPlayer from "react-player";
import livemapVideo from "../../assets/videos/livemap.mp4";

const InteractiveMap = () => {
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          interactiveMap
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content single-project">
        <div className="left">
          {" "}
          <CodeEditorMock>
            Created a{" "}
            <span class="function-color op-1">
              custom interactive map system
            </span>{" "}
            for{" "}
            <span class="html-color-text op-1">Venture Marine Services</span>{" "}
            using <span class="mapbox-color-text op-1">Mapbox GL JS</span>,
            focused on marine operations and vessel visualization.
            <br />
            <br />
            Leveraged <span class="mapbox-color-text op-1">
              Mapbox Studio
            </span>{" "}
            to{" "}
            <span class="string-color-text op-1">
              design a tailored maritime-themed map
            </span>{" "}
            experience that matched the branding and operational needs of the
            company.
            <br />
            <br />
            Implemented advanced{" "}
            <span class="js-color-text op-1">JavaScript logic</span> for{" "}
            <span class="string-color-text op-1">real-time</span> dynamic{" "}
            <span class="function-color op-1">position updates</span>, allowing
            the user to <span class="function-color op-1">track vessels</span>{" "}
            and <span class="function-color op-1">navigate seamlessly</span>{" "}
            through port and oceanic zones with{" "}
            <span class="function-color op-1">smooth transitions</span> and{" "}
            <span class="string-color-text op-1">zoom animations</span>.
            <br />
            <br />
            Designed the system to be{" "}
            <span class="docker-color-text op-1">scalable</span> and{" "}
            <span class="nodejs-color-text op-1">modular</span>, preparing the
            backend to integrate the{" "}
            <span class="api-color-text op-1">MarineTraffic API</span> for{" "}
            <span class="string-color-text op-1">external vessel data</span> in
            the near future.
            <br />
            <br />
            This project was developed as a{" "}
            <span class="react-color-text op-1">standalone React app</span> with
            a <span class="nodejs-color-text op-1">Node.js + Express</span>{" "}
            server, designed to{" "}
            <span class="function-color op-1">deliver fast responses</span> and
            maintain{" "}
            <span class="string-color-text op-1">
              real-time location updates
            </span>{" "}
            using <span class="nodejs-color-text op-1">WebSocket</span> support.
          </CodeEditorMock>
        </div>

        <div className="right">
          <div className="box-container no-padding">
            <video className="livemap-video" autoPlay loop muted playsInline>
              <source src={livemapVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="box-container">
            <CodeEditorMock>
              <span class="const-color">const</span>{" "}
              <span class="function-color">liveMap</span> = () =&gt; {"{"}
              <br />
              &nbsp;&nbsp;
              <span class="comment-color">
                // Custom map interface for Venture Marine Services
              </span>
              <br />
              &nbsp;&nbsp;<span class="const-color">const</span>{" "}
              <span class="variable-color">map</span> ={" "}
              <span class="function-color">Mapbox.initialize</span>({"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="variable-color">
                style
              </span>:{" "}
              <span class="string-color-text">
                "custom-designed via Mapbox Studio"
              </span>
              ,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">features</span>: [
              <span class="string-color-text">
                "real-time location updates"
              </span>
              , <span class="string-color-text">"zoom animations"</span>],
              <br />
              &nbsp;&nbsp;{"}"});
              <br />
              <br />
              &nbsp;&nbsp;
              <span class="comment-color">
                // Built with flexibility in mind for vessel tracking
              </span>
              <br />
              &nbsp;&nbsp;<span class="const-color">const</span>{" "}
              <span class="variable-color">vesselTracking</span> ={" "}
              <span class="function-color">
                MarineTraffic.prepareIntegration
              </span>
              ();
              <br />
              <br />
              &nbsp;&nbsp;
              <span class="function-color">map.enableLiveTracking</span>(
              <span class="variable-color">vesselTracking</span>);
              <br />
              <br />
              &nbsp;&nbsp;<span class="return-color">return</span>{" "}
              <span class="string-color-text">
                "Fully interactive, beautifully designed and API-ready marine
                map system."
              </span>
              ;
              <br />
              {"}"};
            </CodeEditorMock>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveMap;
